import {
    HttpEditProjectClinicalPresentationsPayload,
    httpEditProjectClinicalPresentations
} from '@/features/projects/http/projects.http'
import {QUERY_KEYS, queryClient} from '@/queryClient'
import {ErrorResponseData} from '@/types'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

export const useEditClinicalPresentations = (
    urlParams: {projectId: string},
    options?: UseMutationOptions<unknown, AxiosError<ErrorResponseData>, HttpEditProjectClinicalPresentationsPayload>
) => {
    return useMutation({
        ...options,
        mutationFn: (payload: HttpEditProjectClinicalPresentationsPayload) =>
            httpEditProjectClinicalPresentations({urlParams, payload}),
        // Refetch the project so the header progressStatus (backend-computed) reflects this change.
        onSuccess: (data, variables, context) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECT, urlParams.projectId]})
            options?.onSuccess?.(data, variables, context)
        }
    })
}
